// extracted by mini-css-extract-plugin
module.exports = {"arrow":"TradeRowLabel_arrow__3qwXv","sellTitle":"TradeRowLabel_sellTitle__3UyEC"};